import type { FC } from "react";
import { cn } from "../utils";
import { Button, type ButtonProps } from "./button";

export const ButtonToggle: FC<ButtonProps & { active: boolean }> = ({ active, className, ...props }) => (
  <Button
    variant={active ? "secondary" : "ghost"}
    theme={active ? "primary" : "default"}
    size="sm"
    display="icon"
    className={cn(active && "filled", className)}
    {...props}
  />
);
